<template>
    <div class="container-fluid  pt-2">
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <h5>Transfer Orders</h5>
            </div>
            <div class="col-md-6 col-sm-12 text-right">
                <button class="btn btn-sm btn-primary mr-1" @click="$refs.createTransferModal.open()">
                    New Transfer
                </button>
                <button v-if="isAdmin" class="btn btn-sm btn-outline-primary" @click="$refs.transferAllModal.open()">
                    Transfer All to Branch...
                </button>
             </div>
        </div>

        <hr />

        <div class="row py-1">
            <div class="col-md-6 col-sm-12 py-1">
                <form>
                    <div class="input-group w-100 my-1">
                        <input type="text" class="form-control" v-model="searchItem" placeholder="Search Transfer, enter order">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="submit">
                                        <i class="fa fa-search"></i>
                                    </button>
                        </div>
                    </div>
                </form>
            </div>

            <div class="col-md-6 col-sm-12 py-2">

                <date-range-picker :auto-apply="autoApply" v-model="dateRange" :ranges="ranges" :opens="datepicker_opens" :append-to-body="append_to_body" class="custom-width-datepicker pb-2">
                            <template #input="picker" style="width: 100% !important;">
                                                        <p v-if="picker.startDate !==null && picker.endDate !==null">{{ formatDate(picker.startDate,'DD-MMM-YYYY') }} - {{ formatDate(picker.endDate,'DD-MMM-YYYY') }}</p>
                                                        <p v-else><i class="bi bi-calendar-event"></i>  Filter by Date</p>
                            </template>
                                            </date-range-picker>
            </div>
        </div>
        <div v-if="selectedTransferIds.length > 0" class="row py-1">
            <div class="col-12">
                <span class="mr-2">{{ selectedTransferIds.length }} selected</span>
                <a v-if="selectedApprovable.length > 0"
                    class="btn btn-sm btn-danger mr-1"
                    :class="{ disabled: bulkActionInProgress }"
                    @click="bulkApprove">Approve Selected ({{ selectedApprovable.length }})</a>
                <a v-if="selectedCancellable.length > 0"
                    class="btn btn-sm btn-dark mr-1"
                    :class="{ disabled: bulkActionInProgress }"
                    @click="bulkCancel">Cancel Selected ({{ selectedCancellable.length }})</a>
                <a class="btn btn-sm btn-outline-secondary" @click="selectedTransferIds = []">Clear Selection</a>
            </div>
        </div>
        <div v-if="loadingDone" style="margin-bottom: 5em;">
            <b-table
                striped class="text-primary"
                hover
                small
                sticky-header="100vh"
                :items="transferOrdersFiltered"
                :fields="fields"
                sort-icon-left
                responsive="sm"
                @row-clicked="rowSelected"
            >
            <template #head(selected)>
                <input type="checkbox" :checked="allSelectableSelected" @change="toggleSelectAll($event)" />
            </template>
            <template #cell(selected)="data">
                <input type="checkbox"
                    :disabled="!isRowSelectable(data.item)"
                    :checked="selectedTransferIds.includes(data.item.id)"
                    @click.stop
                    @change="toggleSelectTransfer(data.item.id)" />
            </template>
            <template #cell(created_at)="data">
                <p>{{ formatDate(data.item.created_at,'hh:mm A DD-MM-Y') }}</p>
            </template>
            <template #cell(receiver)="data">
                <p v-if="data.item.receiver">{{ data.item.receiver.full_name || data.item.receiver.name }}</p>
            </template>
            <template #cell(creator)="data">
                <p v-if="data.item.creator">{{ data.item.creator.full_name || data.item.creator.name }}</p>
            </template>
            <template #cell(source_branch)="data">
                <p v-if="data.item.source_branch">{{ data.item.source_branch.name }}</p>
            </template>
            <template #cell(destination_branch)="data">
                <p v-if="data.item.destination_branch">{{ data.item.destination_branch.name }} </p>
            </template>
            <template #cell(completed)="data">
                <p v-if="data.item.status === 'completed'"><span class="badge badge-success">Transferred</span> </p>
                <p v-else-if="data.item.status === 'partial'"><span class="badge badge-warning">Partial</span> </p>
                <p v-else-if="data.item.status === 'cancelled'"><span class="badge badge-secondary">Cancelled</span> </p>
                <p v-else><span class="badge badge-danger">Pending</span> </p>
            </template>
            <template #cell(actions)="data">
                <div @click.stop>
                    <b-dropdown right no-caret variant="secondary" size="sm" toggle-class="px-2">
                        <template #button-content>
                            <i class="fas fa-ellipsis-v"></i>
                        </template>
                        <b-dropdown-item @click="rowSelected(data.item)">View</b-dropdown-item>
                        <b-dropdown-item v-if="canApproveTransferFor(data.item)" @click="openApproveForRow(data.item)">Approve</b-dropdown-item>
                        <b-dropdown-item v-if="canEditTransferFor(data.item)" @click="openEditForRow(data.item)">Edit</b-dropdown-item>
                        <b-dropdown-item v-if="canCancelTransferFor(data.item)" @click="openCancelForRow(data.item)">Cancel</b-dropdown-item>
                    </b-dropdown>
                </div>
            </template>

            </b-table>
        </div>
        <div v-else>
            <loader-spin isVisible text="Loading transfers" />
        </div>
        <b-modal ref="orderDetailsModal" size="lg" hide-footer>

            <div class="text-left" v-if="orderToShow">
                    <h6 class="py-1">Order No:  &nbsp; {{orderToShow.transfer_code}}</h6>

                    <h6 v-if="orderToShow.total_amount" class="py-2">Order Amount:  &nbsp; {{convertCurrencyToShillings(orderToShow.total_amount)}}</h6>
                    <h6 v-if="orderToShow.receipt" class="">Receipt:  &nbsp; {{orderToShow.receipt}}</h6>
                    <p class="py-1">Time:&nbsp; <span class="">{{formatDate(orderToShow.created_at,'hh:mm A')}}</span></p>
                    <p class="py-1">Date:&nbsp; <span class="">{{formatDate(orderToShow.created_at,'DD-MMM-YYYY')}}</span></p>
                    <p v-if="orderToShow.creator" class="py-1">Created by:&nbsp;<span class="text-capitalize">{{ orderToShow.creator.full_name || orderToShow.creator.name }}</span></p>
                    <p v-if="orderToShow.receiver" class="py-1">Received by:&nbsp;<span class="text-capitalize">{{ orderToShow.receiver.full_name || orderToShow.receiver.name }}</span></p>

                    </div>
                   <hr/>
                <div class="text-left">
                    <h5>
                        Transfer order list
                    </h5>
                </div>
                <div class="text-left">
                    <!-- MESSAGE -->
                    <div v-if="!canApproveTransfer && transferBlockMessage"
                        class="alert alert-warning">
                    {{ transferBlockMessage }}
                    </div>
                  <a v-if="canApproveTransfer && orderToShow !== 'completed'" v-b-modal="'verify-po-transfer-b4-submit'" class="btn btn-sm btn-danger">Approve Transfer</a>
                  <a v-if="canEditTransfer" @click="openEditTransfer" class="btn btn-sm btn-secondary ml-1">Edit Transfer</a>
                  <a v-if="canCancelTransfer" v-b-modal="'cancel-transfer-confirm'" class="btn btn-sm btn-dark ml-1">Cancel Transfer</a>
                </div>
                <div class="table-responsive">
                <table class="table table-hover">
                    <thead>

                        <td>#</td>
                        <td>Item</td>
                        <td>Qty</td>
                        <td>Action</td>

                    </thead>
                    <tbody>
                        <tr v-if="orderToShow" v-for="item in orderToShow.items" :key="item.id"
                            :class="{ 'table-success': item.transferred === 1 || clickedTransfers.includes(item.id) }">
                        <td>#</td>
                        <td v-if="item.product">{{ item.product.product }}</td>
                        <td>{{ item.count }}</td>
                        <td>
                            <span v-if="item.transferred === 1 || clickedTransfers.includes(item.id)"
                                  class="badge badge-success">
                                <i class="fas fa-check mr-1"></i>Transferred
                            </span>
                            <a v-else-if="canApproveTransfer"
                               class="btn btn-sm btn-outline-secondary"
                               @click="handleTransfer(item.id)">Transfer</a>
                        </td>
                    </tr>
                    </tbody>

                    </table>
                </div>



           </b-modal>
        <b-modal id="verify-po-transfer-b4-submit" hide-footer>
            <div class="text-center">
                <div class="py-4">
                    <p>Approve transfer <strong>{{ orderToShow.transfer_code }}</strong>?</p>
                    <p v-if="pendingItemsCount > 0" class="text-muted">
                        This will transfer <strong>{{ pendingItemsCount }}</strong>
                        remaining item{{ pendingItemsCount !== 1 ? 's' : '' }}.
                    </p>

                    <a @click="confirmTransfer"
                        class="btn btn-primary"
                        :class="{ 'disabled': !confirmIsNotComplete }"
                        :disabled="!confirmIsNotComplete">
                        Yes! Transfer
                    </a>
                </div>
            </div>
        </b-modal>
        <b-modal id="cancel-transfer-confirm" hide-footer>
            <div class="text-center" v-if="orderToShow">
                <div class="py-4">
                    <p>Cancel transfer <strong>{{ orderToShow.transfer_code }}</strong>?</p>
                    <p class="text-muted">This can only be done before any items have been transferred.</p>
                    <div class="form-group text-left">
                        <label>Reason (optional)</label>
                        <textarea class="form-control" rows="2" v-model="cancelReason"></textarea>
                    </div>

                    <a @click="confirmCancelTransfer"
                        class="btn btn-dark"
                        :class="{ 'disabled': !cancelIsNotSubmitting }"
                        :disabled="!cancelIsNotSubmitting">
                        Yes, Cancel Transfer
                    </a>
                </div>
            </div>
        </b-modal>
        <b-modal ref="editTransferModal" id="edit-transfer-modal" size="lg" hide-footer>
            <div v-if="editTransferForm" class="text-left">
                <h6 class="py-2">Edit Transfer {{ orderToShow.transfer_code }}</h6>

                <div class="form-group">
                    <label>Destination Branch</label>
                    <select class="form-control" v-model="editTransferForm.destination_branch" @change="fetchEditBranchEmployees(editTransferForm.destination_branch)">
                        <option v-for="branch in otherBranches" :key="branch.id" :value="branch.company ? branch.company.id : branch.id">
                            {{ branch.company ? branch.company.name : branch.name }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label>Recipient</label>
                    <select class="form-control" v-model="editTransferForm.received_by">
                        <option :value="null">No specific recipient</option>
                        <option v-for="employee in editBranchEmployees" :key="employee.id" :value="employee.users.id">
                            {{ employee.users.full_name || employee.users.name }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label>Comment</label>
                    <textarea class="form-control" rows="2" v-model="editTransferForm.comment"></textarea>
                </div>

                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <td>Item</td>
                                <td>Qty</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, idx) in editTransferForm.items" :key="item.id">
                                <td>{{ item.product_name }}</td>
                                <td>
                                    <input type="number" min="1" class="form-control" v-model.number="item.quantity" />
                                </td>
                                <td>
                                    <a class="text-danger" @click="editTransferForm.items.splice(idx, 1)">
                                        <i class="fas fa-trash"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <a @click="submitEditTransfer"
                    class="btn btn-primary"
                    :class="{ 'disabled': !editIsNotSubmitting || editTransferForm.items.length === 0 }"
                    :disabled="!editIsNotSubmitting || editTransferForm.items.length === 0">
                    Save Changes
                </a>
            </div>
        </b-modal>

        <transfer-all-modal ref="transferAllModal" @completed="getTransfers"></transfer-all-modal>
        <create-transfer-modal ref="createTransferModal" @created="getTransfers"></create-transfer-modal>
   </div>


</template>

<script>
import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import {mapGetters} from 'vuex'
    import TransferAllModal from './TransferAllModal.vue'
    import CreateTransferModal from './CreateTransferModal.vue'
    export default {
        name: 'products',
        components: {
            DateRangePicker,
            TransferAllModal,
            CreateTransferModal
        },
        data() {
            return {
                loadingDone:false,
                editprodform: {
                    title: '',
                    ppu: '',
                    wholesale_sp: '',
                    measuring: '',
                    product_id: '',
                    remaining_units: '',
                    wholesale_ppu: ''
                },
                confirmIsNotComplete:true,
                groupItems:{
                    group_title:'',
                    cost:'',
                    wholesale:'',
                    groupItemsArray:[],

                },
                clickedTransfers: [],
                inventoryItemsDetails:{
                    searchTerm: '',
                    searchTable: false,
                    filteredInventoryItems: {},
                    selectedInventoryItem: {},
                    product: {}
                },

                fields: [{
                        key: "selected",
                        sortable: false,
                        label: ""
                    },
                    {
                        key: "transfer_code",
                        sortable: true,
                        label:"Transfer Order"
                    },

                    {
                        key: "destination_branch",
                        sortable: true,
                        label:"To"
                    },
                    {
                        key: "source_branch",
                        sortable: true,
                        label:"From"
                    },
                    {
                        key: "creator",
                        sortable: true,
                        label:"Created By"
                    },
                    {
                        key: "receiver",
                        sortable: true,
                        label:"Recipient"
                    },
                    {
                        key: "completed",
                        sortable: true,
                        label:"Status"
                    },
                    {
                        key: "created_at",
                        sortable: true,
                        label:"Date"
                    },
                    {
                        key: "actions",
                        sortable: false,
                        label:"Actions"
                    }

                ],
                selectedTransferIds: [],
                bulkActionInProgress: false,
                transferOrders:[],
                dateRange: {
                    startDate: null,
                    endDate: null,
                },
                selectedSupplier:null,
                autoApply: true,
                append_to_body: true,
                datepicker_opens: 'right',
                ranges: false,

                userRole: '',

                companySettings: '',
                searchItem: '',
                items: [],
                totalAmountOftransfers: 0,
                totalPendingBalances: 0,

                selectedProduct: {
                    allOtherItems:{
                        grouped_items:[],
                    },
                },
                transfersCount:'',
                purchaseItems:'',
                purchaseDetails:'',
                supplierCount:'',
                suppliers:{},
                orderToShow:{},

                cancelReason: '',
                cancelIsNotSubmitting: true,
                editIsNotSubmitting: true,
                editTransferForm: null,
                otherBranches: [],
                editBranchEmployees: [],
            }

        },
        computed:{
            ...mapGetters(['userDetails']),
            transferOrdersFiltered() {
                    return this.transferOrders.filter(item => {
                        const transferOrder = item.transfer_code ? item.transfer_code.toLowerCase() : '';

                        return transferOrder.includes(this.searchItem.toLowerCase()) || supplier.includes(this.searchItem.toLowerCase());
                    });
            },
                isReceivingCompany() {
                    return this.isReceivingCompanyFor(this.orderToShow);
                },

                isSendingCompany() {
                    return this.isSendingCompanyFor(this.orderToShow);
                },

                canEditTransfer() {
                    return this.canEditTransferFor(this.orderToShow);
                },

                canCancelTransfer() {
                    return this.canCancelTransferFor(this.orderToShow);
                },

                canApproveTransfer() {
                    return this.canApproveTransferFor(this.orderToShow);
                },

                selectableTransfers() {
                    return this.transferOrdersFiltered.filter(t => this.isRowSelectable(t));
                },

                allSelectableSelected() {
                    return this.selectableTransfers.length > 0 &&
                        this.selectableTransfers.every(t => this.selectedTransferIds.includes(t.id));
                },

                selectedCancellable() {
                    return this.transferOrders.filter(
                        t => this.selectedTransferIds.includes(t.id) && this.canCancelTransferFor(t)
                    );
                },

                selectedApprovable() {
                    return this.transferOrders.filter(
                        t => this.selectedTransferIds.includes(t.id) && this.canApproveTransferFor(t)
                    );
                },

                isAdmin() {
                    return (

                    this.userDetails.roles?.[0]?.name === "Admin"
                    );
                },

                transferBlockMessage() {

                    if (!this.orderToShow) return '';

                    if (!this.isReceivingCompany) {
                        return "You can only approve transfers for your receiving company.";
                    }

                    if (!this.isAdmin && !this.isAssignedReceiverFor(this.orderToShow)) {
                        return "Only Admin or assigned receiver can approve this transfer.";
                    }

                    if (!this.isAdmin && !this.hasPermission('can transfer')) {
                        return "You do not have permission to receive stock.";
                    }

                    if (this.orderToShow.completed === 1 || this.orderToShow.status === 'completed') {
                        return "This transfer has already been completed.";
                    }

                    if (this.orderToShow.status === 'processing') {
                        return "This transfer is currently being processed by another user. Please wait a moment and refresh.";
                    }

                    if (this.orderToShow.status === 'cancelled') {
                        return "This transfer has been cancelled.";
                    }

                    return "";
                },

                pendingItemsCount() {
                    if (!this.orderToShow || !this.orderToShow.items) return 0;
                    return this.orderToShow.items.filter(
                        item => item.transferred !== 1 && !this.clickedTransfers.includes(item.id)
                    ).length;
                },

    },



        watch: {
            dateRange: {
                deep: true,
                handler(after, before) {
                    if (after.startDate && after.endDate) {
                        const urlParams = new URLSearchParams(window.location.search);
                        const startDateString = after.startDate.toISOString().split('T')[0]; // Convert to ISO format without time
                        const endDateString = after.endDate.toISOString().split('T')[0]; // Convert to ISO format without time

                        urlParams.set('start-date', startDateString);
                        urlParams.set('end-date', endDateString);

                        window.history.replaceState(null, null, '?' + urlParams.toString());
                     }
                    this.getTransfers()
                }

            },
            selectedSupplier:{
                handler(after,before){

                        const urlParams = new URLSearchParams(window.location.search);

                        urlParams.set('supplier', this.selectedSupplier);


                        window.history.replaceState(null, null, '?' + urlParams.toString());

                    this.getTransfers()

                }
            }
        },


        mounted() {

            this.getTransfers()
            this.fetchOtherBranches()


        },
        methods: {
           async getTransfers() {
            this.loadingDone = false
                const urlParams = new URLSearchParams(window.location.search);
               await axios.get('/api/transfer-stocks',{params:{
                    startdate: urlParams.get('start-date'),
                    enddate: urlParams.get('end-date'),


                 }})
                    .then(results => {
                        this.transferOrders = results.data.data
                        this.suppliers = results.data.supplierList
                        this.loadingDone = true

                    }).catch(errors => {});
            },
            async confirmTransfer() {
            if (!this.confirmIsNotComplete) return;
            this.confirmIsNotComplete = false;

            // Re-fetch current server state before committing — guards against two
            // users both having the same modal open and clicking simultaneously
            try {
                const fresh = await axios.get(`/api/transfer-stocks/${this.orderToShow.id}`);
                if (fresh.data.completed || fresh.data.status === 'completed') {
                    this.$toasts.push({ type: 'warning', message: 'This transfer has already been completed by another user.' });
                    this.orderToShow = fresh.data;
                    this.confirmIsNotComplete = false;
                    this.$bvModal.hide('verify-po-transfer-b4-submit');
                    return;
                }
            } catch (_) {
                // If the re-fetch fails, proceed — server-side CAS is the definitive guard
            }

            const idempotencyKey = sessionStorage.getItem(`transfer_key_${this.orderToShow.id}`)
                || `${this.orderToShow.id}-${Date.now()}`;
            sessionStorage.setItem(`transfer_key_${this.orderToShow.id}`, idempotencyKey);

            axios.post(`/api/transfer-stocks/${this.orderToShow.id}/complete`, {}, {
                headers: { 'Idempotency-Key': idempotencyKey },
            })
                .then(results => {
                    if (results.status === 200) {
                        sessionStorage.removeItem(`transfer_key_${this.orderToShow.id}`);
                        window.location.reload();
                    }
                })
                .catch(error => {
                    // Re-enable so user can retry; server-side idempotency prevents double-processing
                    this.confirmIsNotComplete = true;

                    this.$toasts.push({
                        type: 'danger',
                        message: (error.response?.data?.error || error.response?.data?.message) || 'Something went wrong. Please try again.',
                    });
                });
        },
     handleTransfer(id) {
    // prevent double click
    if (this.clickedTransfers.includes(id)){
        console.log("--------EXISTS---------")
    return;
    }
    console.log("--------First---------")
    this.clickedTransfers.push(id);

    // call your original method
    this.confirmOneItemTransfer(id);
  },
            confirmOneItemTransfer(itemId) {
            this.confirmIsNotComplete = false;

            axios.post(`/api/transfer-stocks/${this.orderToShow.id}/${itemId}/complete`)
                .then(results => {
                    if (results.status === 200) {
                        this.confirmIsNotComplete = true;
                        // Patch orderToShow so the "Transferred" badge appears immediately
                        // and pendingItemsCount updates without a page reload
                        if (results.data && results.data.data) {
                            this.orderToShow = results.data.data;
                        }
                    }
                })
                .catch(error => {
                    this.confirmIsNotComplete = true;
                    this.clickedTransfers = this.clickedTransfers.filter(id => id !== itemId);

                    this.$toasts.push({
                        type: 'danger',
                        message: (error.response && error.response.data && error.response.data.message)
                            || 'Something went wrong. Please try again.'
                    });
                });
        },


            hasPermission(permissionName) {

                 return (this.userDetails?.permissions || []).some(permission => permission.name === permissionName);
            },

            isSendingCompanyFor(transfer) {
                if (!transfer?.source_branch_id) return false;

                return String(this.userDetails.company_id) === String(transfer.source_branch_id);
            },

            isReceivingCompanyFor(transfer) {
                if (!transfer?.destination_branch_id) return false;

                return String(this.userDetails.company_id) === String(transfer.destination_branch_id);
            },

            isAssignedReceiverFor(transfer) {
                if (!transfer?.received_by) return false;

                return transfer.received_by === this.userDetails.id;
            },

            canApproveTransferFor(transfer) {
                if (!transfer) return false;

                const isNotDone = transfer.completed === 0 &&
                    !['completed', 'cancelled', 'processing'].includes(transfer.status);

                return (
                    isNotDone &&
                    this.isReceivingCompanyFor(transfer) &&
                    (this.isAdmin || this.isAssignedReceiverFor(transfer)) &&
                    (this.isAdmin || this.hasPermission('can transfer'))
                );
            },

            canEditTransferFor(transfer) {
                if (!transfer) return false;

                return (
                    transfer.status === 'pending' &&
                    this.isSendingCompanyFor(transfer) &&
                    (this.isAdmin || this.hasPermission('edit-transfer') || this.hasPermission('can transfer'))
                );
            },

            canCancelTransferFor(transfer) {
                if (!transfer) return false;

                return (
                    transfer.status === 'pending' &&
                    (this.isSendingCompanyFor(transfer) || this.isReceivingCompanyFor(transfer)) &&
                    (this.isAdmin || this.hasPermission('cancel-transfer') || this.hasPermission('can transfer'))
                );
            },

            isRowSelectable(transfer) {
                return this.canApproveTransferFor(transfer) ||
                    this.canEditTransferFor(transfer) ||
                    this.canCancelTransferFor(transfer);
            },

            toggleSelectTransfer(id) {
                const idx = this.selectedTransferIds.indexOf(id);
                if (idx === -1) {
                    this.selectedTransferIds.push(id);
                } else {
                    this.selectedTransferIds.splice(idx, 1);
                }
            },

            toggleSelectAll(event) {
                this.selectedTransferIds = event.target.checked
                    ? this.selectableTransfers.map(t => t.id)
                    : [];
            },

            openApproveForRow(transfer) {
                this.orderToShow = transfer;
                this.$bvModal.show('verify-po-transfer-b4-submit');
            },

            openEditForRow(transfer) {
                this.orderToShow = transfer;
                this.openEditTransfer();
            },

            openCancelForRow(transfer) {
                this.orderToShow = transfer;
                this.cancelReason = '';
                this.$bvModal.show('cancel-transfer-confirm');
            },

            async bulkApprove() {
                if (this.bulkActionInProgress) return;
                this.bulkActionInProgress = true;

                const targets = this.selectedApprovable;
                let success = 0, failed = 0;

                for (const transfer of targets) {
                    try {
                        await axios.post(`/api/transfer-stocks/${transfer.id}/complete`, {}, {
                            headers: { 'Idempotency-Key': `${transfer.id}-bulk-${Date.now()}` },
                        });
                        success++;
                    } catch (e) {
                        failed++;
                    }
                }

                this.bulkActionInProgress = false;
                this.selectedTransferIds = [];
                this.$toasts.push({
                    type: failed ? 'danger' : 'success',
                    message: `Approved ${success} transfer(s).` + (failed ? ` ${failed} failed.` : ''),
                });
                this.getTransfers();
            },

            async bulkCancel() {
                if (this.bulkActionInProgress) return;
                this.bulkActionInProgress = true;

                const targets = this.selectedCancellable;
                let success = 0, failed = 0;

                for (const transfer of targets) {
                    try {
                        await axios.post(`/api/transfer-stocks/${transfer.id}/cancel`, {
                            reason: 'Bulk cancelled',
                        }, {
                            headers: { 'Idempotency-Key': `${transfer.id}-bulk-cancel-${Date.now()}` },
                        });
                        success++;
                    } catch (e) {
                        failed++;
                    }
                }

                this.bulkActionInProgress = false;
                this.selectedTransferIds = [];
                this.$toasts.push({
                    type: failed ? 'danger' : 'success',
                    message: `Cancelled ${success} transfer(s).` + (failed ? ` ${failed} failed.` : ''),
                });
                this.getTransfers();
            },

            async fetchOtherBranches() {
                try {
                    const res = await axios.get('/api/other-branches');
                    this.otherBranches = res.data;
                } catch (e) {
                    this.otherBranches = [];
                }
            },

            async fetchEditBranchEmployees(branchId) {
                if (!branchId) {
                    this.editBranchEmployees = [];
                    return;
                }
                try {
                    const res = await axios.get(`/api/branch-employees/${branchId}`);
                    this.editBranchEmployees = res.data;
                } catch (e) {
                    this.editBranchEmployees = [];
                }
            },

            openEditTransfer() {
                if (!this.orderToShow || !this.orderToShow.items) return;

                this.editTransferForm = {
                    destination_branch: this.orderToShow.destination_branch_id,
                    received_by: this.orderToShow.received_by,
                    comment: this.orderToShow.comment,
                    items: this.orderToShow.items.map(item => ({
                        id: item.product_id,
                        product_name: item.product ? item.product.product : '',
                        quantity: item.count,
                    })),
                };

                this.fetchEditBranchEmployees(this.editTransferForm.destination_branch);
                this.$refs.orderDetailsModal.hide();
                this.$refs.editTransferModal.show();
            },

            async submitEditTransfer() {
                if (!this.editIsNotSubmitting || !this.editTransferForm) return;
                if (this.editTransferForm.items.length === 0) {
                    this.$toasts.push({ type: 'danger', message: 'A transfer must have at least one item.' });
                    return;
                }

                this.editIsNotSubmitting = false;

                try {
                    const results = await axios.put(`/api/transfer-stocks/${this.orderToShow.id}`, {
                        destination_branch: this.editTransferForm.destination_branch,
                        received_by: this.editTransferForm.received_by,
                        comment: this.editTransferForm.comment,
                        items: this.editTransferForm.items.map(item => ({ id: item.id, quantity: item.quantity })),
                    });

                    this.editIsNotSubmitting = true;
                    this.$refs.editTransferModal.hide();
                    window.location.reload();
                } catch (error) {
                    this.editIsNotSubmitting = true;
                    this.$toasts.push({
                        type: 'danger',
                        message: (error.response?.data?.message) || 'Something went wrong. Please try again.',
                    });
                }
            },

            async confirmCancelTransfer() {
                if (!this.cancelIsNotSubmitting) return;
                this.cancelIsNotSubmitting = false;

                const idempotencyKey = sessionStorage.getItem(`transfer_cancel_key_${this.orderToShow.id}`)
                    || `${this.orderToShow.id}-cancel-${Date.now()}`;
                sessionStorage.setItem(`transfer_cancel_key_${this.orderToShow.id}`, idempotencyKey);

                try {
                    await axios.post(`/api/transfer-stocks/${this.orderToShow.id}/cancel`, {
                        reason: this.cancelReason,
                    }, {
                        headers: { 'Idempotency-Key': idempotencyKey },
                    });

                    sessionStorage.removeItem(`transfer_cancel_key_${this.orderToShow.id}`);
                    window.location.reload();
                } catch (error) {
                    this.cancelIsNotSubmitting = true;
                    this.$toasts.push({
                        type: 'danger',
                        message: (error.response?.data?.message) || 'Something went wrong. Please try again.',
                    });
                }
            },

            getProducts() {
                axios.get('/api/all-items-and-count').then(results => {
                    this.inventoryItemsDetails.product = results.data.items
                    // console.log(results.data.items)
                }).catch(error => {})
            },

            productSelected(item){
                this.groupItems.groupItemsArray.push(item)
                this.inventoryItemsDetails.filteredInventoryItems=[]
                console.log(this.groupItems.groupItemsArray)
            },
            searchInventoryItem() {
                const searchTerm = this.inventoryItemsDetails.searchTerm.toLowerCase();
                this.inventoryItemsDetails.filteredInventoryItems = this.inventoryItemsDetails.product.filter(product =>
                    (product.product && product.product.toLowerCase().includes(searchTerm))

                );

            },

            rowSelected(items) {


                this.orderToShow = items



                this.$refs.orderDetailsModal.show();

            },


            searchQueryItems() {
                this.getProducts();
            },
            formatDate(date, format) {
                return moment(date).format(format);
            },


    }
}
</script>


